<template>
	<nk-wrapper v-if="context.leistung" spacing="lg">
		<section>
			<nk-title tag="h1" size="2xl">
				{{ context.leistung.name }}
			</nk-title>

			<!-- Ämter -->
			<nk-wrapper>
				<template
					v-if="
						context.leistung.kontaktpersonen &&
						context.leistung.kontaktpersonen.length
					"
				>
					<nk-title tag="h2" size="xl">Für Sie zuständige Mitarbeiter</nk-title>
					<nk-row vertical-gutter="2" gutter="2">
						<nk-col
							v-for="(mitarbeiter, mitarbeiterIndex) in context.leistung
								.kontaktpersonen"
							:key="`mitarbeiter-${mitarbeiterIndex}`"
							cols="full"
							sm="6/12"
						>
							<nk-card variant="boxed" :grouped="false">
								<template #header>
									<nk-link
										block
										:link="`${
											context.taggingpfadMitarbeiter.slice(-1) !== '/'
												? context.taggingpfadMitarbeiter + '/'
												: context.taggingpfadMitarbeiter
										}${
											$slugify(
												mitarbeiter.vorname + '-' + mitarbeiter.nachname,
											) +
											'-id_' +
											mitarbeiter.id
										}`"
									>
										<nk-title tag="h3" size="md" no-margin>
											{{ mitarbeiter.vorname }}
											{{ mitarbeiter.nachname }}
										</nk-title>
									</nk-link>
									<div v-html="mitarbeiter.funktion" />
								</template>
								<template #body>
									<nk-address
										variant="vertical"
										:email="
											mitarbeiter.kommunikationsmoeglichkeiten &&
											mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'EMAIL',
											)
												? mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'EMAIL',
													).kennung
												: null
										"
										:mobil="
											mitarbeiter.kommunikationsmoeglichkeiten &&
											mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
											)
												? mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'MOBILTELEFON',
													).kennung
												: null
										"
										:telefon="
											mitarbeiter.kommunikationsmoeglichkeiten &&
											mitarbeiter.kommunikationsmoeglichkeiten.find(
												kontaktArt => kontaktArt.kanal === 'TELEFON',
											)
												? mitarbeiter.kommunikationsmoeglichkeiten.find(
														kontaktArt => kontaktArt.kanal === 'TELEFON',
													).kennung
												: null
										"
									/>
								</template>
							</nk-card>
						</nk-col>
					</nk-row>
					<nk-divider />
				</template>
				<template
					v-else-if="
						context.leistung.organisationseinheiten &&
						context.leistung.organisationseinheiten.length
					"
				>
					<nk-title :id="`title-${titleId}`" tag="h2" size="xl">
						Für Sie zuständige Stellen
					</nk-title>

					<nk-nav :aria-labelledby="`title-${titleId}`">
						<nk-nav-item
							v-for="(
								organisationseinheit, organisationseinheitIndex
							) in context.leistung.organisationseinheiten"
							:key="organisationseinheitIndex"
							:link="
								organisationseinheit.extern
									? null
									: `${
											context.taggingpfadOrganisationseinheit.slice(-1) !== '/'
												? context.taggingpfadOrganisationseinheit + '/'
												: context.taggingpfadOrganisationseinheit
										}${
											$slugify(organisationseinheit.name) +
											'-id_' +
											organisationseinheit.id
										}`
							"
						>
							{{ organisationseinheit.name }}
						</nk-nav-item>
					</nk-nav>
				</template>
			</nk-wrapper>

			<!-- Textblock Preamble -->
			<nk-wrapper>
				<div v-html="preambleText" />
			</nk-wrapper>

			<nk-accordion
				v-if="context.leistung.prozesse && context.leistung.prozesse.length"
				v-slot="{titleId: accordionTitleId}"
				group="textblock"
				title="Online Prozesse"
				title-size="lg"
			>
				<nk-nav
					:aria-labelledby="accordionTitleId"
					variant="resources"
					prepend-icon="link"
					append-icon="arrow-right"
				>
					<nk-nav-item
						v-for="(prozess, prozessIndex) in context.leistung.prozesse"
						:key="prozessIndex"
						:link="prozess.url"
						:title="prozess.name"
						:text="prozess.url"
						target="_blank"
					/>
				</nk-nav>
			</nk-accordion>

			<nk-accordion
				v-if="context.leistung.formulare && context.leistung.formulare.length"
				v-slot="{titleId: accordionTitleId}"
				group="textblock"
				title="Formulare"
				title-size="lg"
			>
				<nk-nav :aria-labelledby="accordionTitleId" variant="resources">
					<nk-nav-item
						v-for="(formular, formularIndex) in context.leistung.formulare"
						:key="formularIndex"
						:link="formular.url"
						:prepend-icon="getFileIcon(formular.url)"
					>
						{{ formular.name }}
					</nk-nav-item>
				</nk-nav>
			</nk-accordion>

			<!-- Textbloecke -->
			<template
				v-for="(textblock, textbloeckeIndex) in context.leistung.textbloecke"
			>
				<nk-accordion
					v-if="
						textblock.text &&
						textblock.typ !== 'preamble' &&
						textblock.typ !== 'zustaendigkeit' &&
						textblock.typ !== 'bezugsort' &&
						textblock.typ !== 'freigabevermerk'
					"
					:key="textbloeckeIndex"
					group="textblock"
					:title="textblock.titel"
					title-size="lg"
				>
					<div class="nk-cms-content" v-html="textblock.text" />
				</nk-accordion>
			</template>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {useCMS, updateBreadcrumb, useSEO} from '#nk/composables/cms';
import {useId} from '#imports';

/**
 * @prop {object} context.leistung
 * @prop {object} context.taggingpfadOrganisationseinheit
 * @prop {object} context.taggingpfadMitarbeiter
 */
export default {
	name: 'NkTemplateServiceBwLeistungsDetails',

	mixins: [TemplatesDefault],

	setup(ctx) {
		const page = useCMS();

		const leistung = {
			name: ctx?.context?.leistung?.name || '',
		};

		if (leistung.name) {
			updateBreadcrumb({title: leistung.name});
		}

		useSEO({
			title: page.value.title
				? `${page.value.title} ${leistung.name}`
				: leistung.name,
		});

		const titleId = useId();
		return {titleId};
	},

	computed: {
		preambleText() {
			const {text} = this.context.leistung.textbloecke.find(
				textblock => textblock.typ === 'preamble',
			);
			return text;
		},
	},

	methods: {
		getFileIcon(fileName) {
			const fileExtension = fileName.substr(fileName.lastIndexOf('.') + 1);

			if (['pdf'].includes(fileExtension)) {
				return 'file-pdf';
			}
			if (['png', 'jpg', 'jpeg', 'gif'].includes(fileExtension)) {
				return 'file-image';
			}
			if (['txt'].includes(fileExtension)) {
				return 'file-txt';
			}
			if (['doc', 'docx'].includes(fileExtension)) {
				return 'file-doc';
			}

			return 'file';
		},
	},
};
</script>
